import { Grid, Paper, Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import "../../Styles/strategy.css";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import HeaderIcons from "../../Images/headericon.png";
import AddAssets from "./addAssets";
import StrategyPerformance from "./StrategyPerformance";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";

function Index() {
  const { id } = useParams();
  const [value, setValue] = React.useState("1");
  const [StrategyName, setStrategyName] = useState();
  const { strategies } = useSelector((state) => state?.strategy);
  useEffect(() => {
    if (id && strategies) {
      const findStrategy = strategies.find((i) => i.id == id);
      if (findStrategy) {
        setStrategyName(findStrategy?.name);
      }
    }
  }, [id]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Grid item xs={12}>
        <div
          sx={{ p: 2, display: "flex" }}
          
        >
          <div style={{ padding: "10px 0" }}>
            <Typography 
              variant="h6"
            >
              
              <span className="edit-strategy-text">Edit </span><span className="strategy-name-text"> | {StrategyName}</span>
            </Typography>
          </div>
        </div>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <TabPanel value="1">
              <Box
                sx={{ width: "100%", typography: "body1" }}
                style={{
                  height: "calc(100vh - 180px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <AddAssets />
              </Box>
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </>
  );
}

export default Index;
